/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingSession
 */
export interface TrainingSession {
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    trainingId?: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingSession
     */
    sessionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    endTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingSession
     */
    sessionExtraFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    publicNotes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSession
     */
    privateNotes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingSession
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the TrainingSession interface.
 */
export function instanceOfTrainingSession(value: object): value is TrainingSession {
    return true;
}

export function TrainingSessionFromJSON(json: any): TrainingSession {
    return TrainingSessionFromJSONTyped(json, false);
}

export function TrainingSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trainingId': json['trainingId'] == null ? undefined : json['trainingId'],
        'sessionDate': json['sessionDate'] == null ? undefined : (new Date(json['sessionDate'])),
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'sessionExtraFee': json['sessionExtraFee'] == null ? undefined : json['sessionExtraFee'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'publicNotes': json['publicNotes'] == null ? undefined : json['publicNotes'],
        'privateNotes': json['privateNotes'] == null ? undefined : json['privateNotes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function TrainingSessionToJSON(json: any): TrainingSession {
    return TrainingSessionToJSONTyped(json, false);
}

export function TrainingSessionToJSONTyped(value?: TrainingSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'trainingId': value['trainingId'],
        'sessionDate': value['sessionDate'] == null ? value['sessionDate'] : value['sessionDate'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'sessionExtraFee': value['sessionExtraFee'],
        'notes': value['notes'],
        'publicNotes': value['publicNotes'],
        'privateNotes': value['privateNotes'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

